import { ChangeDetectorRef, Component, forwardRef, OnInit, ViewChild } from '@angular/core'
import { FormControlValueAccessor } from '@mistergreen/shared/angular-directives/abstract-value-accessor'
import { CheckoutDriverComponent } from '../../../ui/components/checkout-driver/checkout-driver.component'
import { DealUserProfileComponent } from '../../../../ui/components/deal-user-profile/deal-user-profile.component'
import { ValidationErrors, FormGroup, NG_VALUE_ACCESSOR, NG_ASYNC_VALIDATORS } from '@angular/forms'
import { filter, pluck, debounceTime } from 'rxjs/operators'
import { UserProfileService } from '../../../../../../framework/authentication/services/user-profile.service'
import { merge, ReplaySubject } from 'rxjs'
import { DealMutationService } from '../../../../services/dealMutation.service'
import { ActivatedRoute } from '@angular/router'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'

@UntilDestroy()
@Component({
    selector: 'mg-configuration-option-text-driver',
    templateUrl: './configuration-option-text-driver.component.html',
    styleUrls: ['./configuration-option-text-driver.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ConfigurationOptionTextDriverComponent),
            multi: true,
        },
        {
            provide: NG_ASYNC_VALIDATORS,
            useExisting: forwardRef(() => ConfigurationOptionTextDriverComponent),
            multi: true,
        },
    ],
})
export class ConfigurationOptionTextDriverComponent extends FormControlValueAccessor implements OnInit {
    form: FormGroup
    configurationId: string
    userIsDriver$: ReplaySubject<boolean> = new ReplaySubject()

    @ViewChild(CheckoutDriverComponent, { static: true })
    private driverPicker: CheckoutDriverComponent

    @ViewChild(DealUserProfileComponent, { static: true })
    private userProfile: DealUserProfileComponent

    constructor(
        private userProfileService: UserProfileService,
        private changeDetection: ChangeDetectorRef,
        private dealMutationService: DealMutationService,
        private route: ActivatedRoute
    ) {
        super()
    }

    ngOnInit() {
        this.route.parent.data
            .pipe(untilDestroyed(this), pluck<any, string>('configurationId'), filter(Boolean))
            .subscribe((id: string) => {
                this.configurationId = id
            })

        this.form = new FormGroup({})

        this.componentFormControl.valueChanges.pipe(untilDestroyed(this), debounceTime(1000)).subscribe(() => {
            this.userIsDriver$.next(this.driverPicker.userIsDriver)
            this.changeDetection.detectChanges()

            const email = this.driverPicker.userIsDriver
                ? this.userProfile.userProfile.emailAddress
                : this.driverPicker.driverEmailAddressControl.value

            if (this.driverPicker.userIsDriver || this.driverPicker.driverEmailAddressControl.valid) {
                this.dealMutationService.updateDealDriver(this.configurationId, email)
            }
        })

        // update validity if user is driver
        merge(this.userProfile.change, this.userProfile.initialized)
            .pipe(
                untilDestroyed(this),
                filter(() => this.driverPicker.userIsDriver)
            )
            .subscribe(async () => {
                this.onChange(this.value)
                if (this.userProfile.valid) {
                    await this.userProfileService.persistUserProfile()
                }
            })
    }

    async validate(): Promise<ValidationErrors | null> {
        const errors: ValidationErrors = {}

        if (!this.componentFormControl.valid) {
            errors.email = 'invalid'
        }

        if (this.driverPicker.userIsDriver && !this.userProfile.valid) {
            errors.profile = 'invalid'
        }

        return Object.keys(errors).length ? errors : null
    }
}
